import { IDebtPaymentPlanOptions } from "./debtPaymentPlanOptions.types"

export class DebtPaymentPlanOptions implements IDebtPaymentPlanOptions {
  constructor(
    public fuelMonthlyPayment: number,
    public maxPlanLengthInMonths: number,
    public minPlanLengthInMonths: number,
    public maxPlanLengthWithApprovalInMonths: number,
    public recommendedPlanLengthsInMonths: number[],
    public totalDebt: number,
    public planType: string | null,
  ) {}
}
